import ajax from 'utils/ajax'
import API from 'api-url'
import store from 'store'
import {
  SET_TOKEN,
  SET_USER,
  SET_INFO,
  SET_ROLES,
  SET_USER_COMPLETION
} from 'utils/constant'

class UserService {
  // 密码登录
  login(params) {
    return ajax.post({
      url: API.user.login,
      data: params
    }, {
      noToken: true
    })
  }
  // 短信登录
  phoelogin(params) {
    return ajax.post({
      url: API.user.phonelogin,
      data: params
    }, {
      noToken: true
    })
  }
  // 二维码登录
  createQrcode(params) {
    return ajax.get({
      url: API.user.createQrcode,
      data: {
        data: params
      }
    })
  }
  // 二维码登录状态
  getLoginResult(params) {
    return ajax.get({
      url: API.user.getLoginResult,
      data: {
        data: params
      }
    })
  }
  // 退出
  logout() {
    return ajax.get({
      url: API.user.logout
    })
  }

  // 用户信息
  info() {
    return ajax
      .get({
        url: API.user.info
      })
      .then(res => {
        store.commit(SET_ROLES, res.data.roles)
        store.commit(SET_INFO, res.data.info)
        store.commit(SET_USER, res.data.user)
        store.commit(SET_USER_COMPLETION, res.data.completion)
        return res
      })
  }

  // 用户信息
  cas() {
    return ajax
      .get({
        url: API.user.cas
      })
      .then(res => {
        if (res && res.data && res.data.authenticated) {
          store.commit(SET_TOKEN, res.data.token)
          store.commit(SET_ROLES, res.data.roles)
          store.commit(SET_INFO, res.data.info)
          store.commit(SET_USER, res.data.user)
          store.commit(SET_USER_COMPLETION, res.data.completion)
        }
        return res
      })
  }

  // 修改个人基础信息
  updateInfo(params) {
    return ajax.put({
      url: API.user.userInfo,
      data: params
    })
  }

  // 注册
  register(params) {
    return ajax.post({
      url: API.user.register,
      data: params
    })
  }

  // 重置密码
  changePassword(params) {
    return ajax.put({
      url: API.user.repwd,
      data: params
    })
  }

  // 重置密码
  changePhone(params) {
    return ajax.post({
      url: API.user.rebp,
      data: params
    })
  }

  // 修改密码
  chPassword(params) {
    return ajax.put({
      url: API.user.chpwd,
      data: params
    })
  }

  // 通过手机号验证用户是否注册
  vaildReg(params) {
    return ajax.get({
      url: API.user.vaildReg,
      data: {
        data: params
      }
    })
  }

  // 评论列表
  commentList(search) {
    return ajax.get({
      url: API.user.commentList,
      data: {
        data: search
      }
    })
  }

  // 用户身份证验证
  identityVerified(params) {
    return ajax.put({
      url: API['user'].identityVerified,
      data: params
    })
  }
  // 实名认证订单获取
  bizNo() {
    return ajax.post({
      url: API.user.bizNo
    })
  }
  // 实名认证状态查询
  getBizNo(params) {
    return ajax.get({
      url: API.user.bizNo,
      data: {
        data: params
      }
    })
  }
  // 实名认证
  certifyQr(params) {
    return ajax.get({
      url: API.user.certifyQr,
      data: {
        data: params
      }
    })
  }
  // 新手引导
  leadState(params) {
    return ajax.get({
      url: API.user.leadState,
      data: {
        data: params
      }
    })
  }
  updateState() {
    return ajax.put({
      url: API.user.updateState
    })
  }
}

export default new UserService()



// WEBPACK FOOTER //
// ./src/service/user-service.js